import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium from 'higher-order-components/configured-radium/'
import { childParser } from 'containers/utilities'
import SwipeableViews from 'react-swipeable-views'
import { StepCounter } from 'components'
import { invokeFuncs } from 'utils/function'

/** Slideshow Component */
class Slideshow extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: props.activate
    }
  }
  static propTypes = {
    children: PropTypes.node,
    noAnimation: PropTypes.bool,
    showBullets: PropTypes.bool,
    bulletsBelow: PropTypes.bool,
    components: PropTypes.array,
    gtmEventsByIndex: PropTypes.array,
    handleChange: PropTypes.func,
    activate: PropTypes.number,
    isItemWrapperStyle: PropTypes.bool
  }
  static defaultProps = {
    activate: 0,
    loop: true,
    isItemWrapperStyle: true
  }
  componentWillReceiveProps(nextProps) {
    nextProps.activate !== null && this.setState({ active: nextProps.activate })
  }
  handleChange = (index, type) => {
    if (type === 'end') {
      this.props.handleChange ? this.props.handleChange(index) : this.setState({ active: index })
    }
    const { gtmEventsByIndex } = this.props
    if (gtmEventsByIndex) {
      gtmEventsByIndex[index] && invokeFuncs(gtmEventsByIndex[index])
    }
  }

  /**
   * @param {Number} [noAnimation] - Do not play swiping animation
   * @param {Boolean} [showBullets] - Display a list of navigation bullets below the slideshow.
   * @param {Boolean} [bulletsBelow] - Display a bullet list below slide.
   * @param {String} [disclaimer] - Dislaimer text as xmlString
   * @param {Array|SlideshowItem} components - Array of components.
   * @returns {ReactElement} React Component
   */
  render() {
    const bulletButtons = this.props.showBullets && (
      <StepCounter
        steps={this.props.components || this.props.children}
        active={this.state.active + 1}
        setStep={(number) => {
          this.handleChange(number - 1, 'end')
        }}
        horizontal />
    )
    return (
      <div data-test="slideshow" style={{overflow:'hidden'}}>
        {!this.props.bulletsBelow && bulletButtons}
        <SwipeableViews
          animateTransitions={!this.props.noAnimation}
          index={this.state.active}
          onSwitching={this.handleChange}
          style={styles.base}
          slideStyle={{ overflow: 'hidden' }}>
          {childParser(this.props).map((component, index) => (
            <div
              data-test={index === this.state.active ? 'active-slide' : 'slide'}
              key={index}
              style={this.props.isItemWrapperStyle ? styles.slideshowItem : undefined}>
              {component}
            </div>
            ))}
        </SwipeableViews>
        {this.props.bulletsBelow && bulletButtons}
      </div>
    )
  }
}

export default Radium(Slideshow)

const styles = {
  base: {
    position: 'relative',
    textAlign: 'center'
  },
  slideshowItem: {
    width: '100%',
    height: '100%'
    // pointerEvents: 'none' Video needs to be playable in slide
  }
}



// WEBPACK FOOTER //
// ./src/components/slideshow/index.jsx